<template>
  <b-row class="mt-2">
    <div
      v-if="isLoading"
      class="text-center w-100"
    >
      <b-spinner label="Spinning" />
    </div>
    <b-col
      cols="12"
    >
      <div class="d-flex justify-content-between py-1">
        <h2> User Trainings </h2>
        <EditAuditsAndTrainings
          :action-type="'Add Training'"
          :open-evaluation-id="openEvaluationId"
          :existing-items="userTrainings"
          @items-added="refreshPersonnelItems"
        />
      </div>
      <PersonnelGeneralTable
        v-if="!isLoading && userTrainings.length > 0"
        :items-user-data="userTrainings"
        :fields-user-data="fieldsUserTrainings"
      />
      <p v-else>
        No data in User Trainings
      </p>
    </b-col>
    <b-col
      cols="12"
      class="my-1"
    >
      <div class="d-flex justify-content-between py-1">
        <h2> User Audits </h2>
        <EditAuditsAndTrainings
          :action-type="'Add Audit'"
          :open-evaluation-id="openEvaluationId"
          :existing-items="userAudits"
          @items-added="refreshPersonnelItems"
        />
      </div>
      <PersonnelGeneralTable
        v-if="!isLoading && userAudits.length > 0"
        :items-user-data="userAudits"
        :fields-user-data="fieldsUserAudits"
      />
      <p v-else>
        No data in User Audits
      </p>
    </b-col>
    <!-- v-if="!isLoading && userRequestEvaluations.length > 0" -->
    <b-col
      cols="12"
      class="my-1"
    >
      <div class="d-flex justify-content-between py-1">
        <h2> Request Evaluations</h2>
      </div>
      <PersonnelGeneralTable
        :items-user-data="userRequestEvaluations"
        :fields-user-data="fieldsUserRequestEvaluations"
        :request-evaluation-id="requestEvaluationId"
        @showRequestsEvaluation="showRequestsEvaluation"
      />
    </b-col>
    <!-- <pre>
      {{userRequestEvaluations}}
    </pre> -->
  </b-row>
</template>

<script>
import axios from 'axios'
// import DOMPurify from 'dompurify'
import decryptData from '@/store/auth/decryptData'
import PersonnelGeneralTable from './PersonnelGeneralTable.vue'
import questions from './questions'
import EditAuditsAndTrainings from '../personnel-action/EditAuditsAndTrainings.vue'

export default {
  components: {
    PersonnelGeneralTable,
    EditAuditsAndTrainings,
  },
  props: {
    openEvaluationId: {
      type: [Number, String],
      required: true,
    },
    // requestEvaluationId: {
    //   type: [Number, String],
    // },
  },
  data() {
    return {
      userTrainings: [],
      userAudits: [],
      userRequestEvaluations: [],
      requestEvaluationId: null,
      fieldsUserTrainings: [
        { key: 'training.name', label: 'Training' },
        { key: 'training_session.from', label: 'From' },
        { key: 'training_session.to', label: 'To' },
        { key: 'training_session.trainer', label: 'Trainer' },
      ],
      fieldsUserAudits: [
        { key: 'product_name', label: 'product name' },
        { key: 'product_number', label: 'product number' },
        { key: 'location', label: 'location' },
        { key: 'audit_date', label: 'audit date' },
        { key: 'description', label: 'description' },
        { key: 'company_name', label: 'company name' },
        { key: 'company_email', label: 'company email' },
        { key: 'country', label: 'country' },
      ],
      fieldsUserRequestEvaluations: [
        { key: 'id', label: 'id' },
        { key: 'request.request_code', label: 'request code' },
        { key: 'created_at', label: 'review date' },
        { key: 'activities', label: 'activities' },
        { key: 'remarks', label: 'remarks' },
        { key: 'requests_evaluation', label: 'show requests evaluation' },
      ],
      questions,
      isLoading: false,
    }
  },
  watch: {
    openEvaluationId: {
      immediate: true,
      handler(newVal) {
        this.getUserPersonnelDetails(newVal)
      },
    },
  },
  methods: {
    refreshPersonnelItems() {
      if (this.openEvaluationId) {
        this.getUserPersonnelDetails(this.openEvaluationId)
      }
    },
    getUserPersonnelDetails(id) {
      this.isLoading = true
      axios.get(`personnel-evaluation/${id}`).then(res => {
        const userDetails = decryptData(res.data.payload).data.items
        if (this.$route.params.id) {
          this.$emit('evaluation-details', decryptData(res.data.payload).data.evaluation)
          this.requestEvaluationId = decryptData(res.data.payload).data.evaluation.certificate_category.id
        }
        this.userTrainings = userDetails.userTrainings
        this.userAudits = userDetails.userAudits
        this.userRequestEvaluations = userDetails.userRequestEvaluations
      }).finally(() => {
        this.isLoading = false
      })
    },
    formatRequestsEvaluation(requestDetails) {
      let tableHTML = `
         ${requestDetails.activities
    ? `<p style="text-align: left !important;">Activities: ${requestDetails.activities}</p>`
    : ''}
    <table style="border: 0.5px solid; border-collapse: collapse; margin-top: 18px !important; margin: auto;">
      <tr style="background-color: #f3f2f7">
        <th style="border: 0.5px solid; padding: 8px; text-align: left;">Part</th>
        <th style="border: 0.5px solid; padding: 8px; text-align: left;">Questions</th>
        <th style="border: 0.5px solid; padding: 8px; text-align: left;">Answers</th>
        <th style="border: 0.5px solid; padding: 8px; text-align: left;">Remarks</th>
      </tr>
  `

      this.questions.forEach(part => {
        const rowSpan = part.inputs.length
        part.inputs.forEach((question, index) => {
          tableHTML += '<tr>'
          if (index === 0) {
            // First question of the group, include the part title with rowspan
            tableHTML += `
          <td style="border: 0.5px solid; padding: 8px; text-wrap: wrap !important; max-width: 10vw!important;" rowspan="${rowSpan}">
            ${part.title}
          </td>
        `
          }
          tableHTML += `
        <td style="border: 1px solid; padding: 8px!important; text-align: left !important; text-wrap: wrap !important; max-width: 30vw!important;">
          ${question.label} ?
        </td>
        <td style="border: 1px solid; padding: 8px; text-align: center !important; text-wrap: wrap !important;  max-width: 10vw!important;"">
          ${requestDetails[question.payloadSelect]}</td>
        <td style="border: 1px solid; padding: 8px!important; text-align: left !important; text-wrap: wrap !important;  max-width: 30vw!important;">
          ${requestDetails[question.payloadInput]}</td>
      `
          tableHTML += '</tr>'
        })
      })

      tableHTML += '</table>'
      return tableHTML
    },
    showRequestsEvaluation(requestDetails) {
      if (requestDetails) {
        this.$swal({
          title: 'Requests Evaluation',
          html: this.formatRequestsEvaluation(requestDetails),
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          width: '80%',
        })
      }
    },
  },
}
</script>
